export default __webpack_public_path__ + "static/ovg-0237c36bcb7d493844997350109302d9.png";